module.exports = GameBoardTemplate = function GameBoardTemplate(game_mod) {
  return "\n<div class=\"gameboard ".concat(game_mod.theme, " ").concat(game_mod === null || game_mod === void 0 ? void 0 : game_mod.felt, "\">\n  <div class=\"deal\" id=\"deal\">\n  </div>\n</div>\n<div class=\"mystuff\"></div>\n\t");
};